// https://developer.mozilla.org/en-US/docs/Web/CSS/@media/hover
if (!window.matchMedia("(hover: hover)").matches) {
  document.documentElement.classList.remove("is-hover")
}
